import { render, staticRenderFns } from "./ErCode.vue?vue&type=template&id=1c67fbf0"
import script from "./ErCode.vue?vue&type=script&lang=js"
export * from "./ErCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports